import { createContext } from 'react';
export interface FeatureFlagsState {
  [featureName: string]: boolean;
}

export const FeatureFlagsContext = createContext<FeatureFlagsState>({});

FeatureFlagsContext.displayName = 'FeatureFlagsContext';
